import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import ChatTutor from "./pages/ChatTutor";
import Practice from "./pages/Practice";
import History from "./pages/History";
import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import PricingPage from "./pages/PricingPage";
import Layout from "./components/Layout";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<LandingPage />} />
              <Route path="chat" element={<ChatTutor />} />
              <Route path="chat/:topicId" element={<ChatTutor />} />
              <Route path="practice" element={<Practice />} />
              <Route path="practice/:topicId" element={<Practice />} />
              <Route path="history" element={<History />} />
              <Route path="auth" element={<AuthPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="pricing" element={<PricingPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
